import { alertTypes } from "shared/dist/components";

export const handleStatusTypes = {
    PENDING: "pending",
    FAILED: "failed",
    SUCCEEDED: "sacceeded",
};

export const demoAlerts = {
    pending: {
        type: alertTypes.WARNING,
        message: "Please, waiting. We're processing your demo file",
    },
    failed: {
        type: alertTypes.ERROR,
        message: "Error processing your demo file. Please check if you have uploaded a valid file",
    },
    succeeded: {
        type: alertTypes.SUCCESS,
        message:
            "File have been uploaded. You can download your files on clicking the download button",
    },
};

export const messagesAlerts = {
    hasNotFiles: "Please upload Demo Files",
    rejectedFile: "File rejected please check the maxSize and type of file",
    indexFileInsideFolder: "The index.js file should not be in a folder",
    hasNotIndexFile: "The zip file should contain index.js file",
};
